import { render } from "./Ad.vue?vue&type=template&id=534a244f"
import script from "./Ad.vue?vue&type=script&lang=js"
export * from "./Ad.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ab-front-library/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__